'use client';
import { useEffect } from 'react';
import { fetchDesignAndWS } from '@/utils/api';

/**
 * DynamicTitle: Fetches /design endpoint and updates:
 * - document.title with design.title
 * - apple-mobile-web-app-title meta tag with design.title
 * - application-name meta tag with design.title
 */
export default function DynamicTitle() {
  useEffect(() => {
    const applyTitle = (title: string) => {
      if (!title) return;
      document.title = title;
      // Update PWA-related meta tags if they exist
      const appleMeta = document.querySelector('meta[name="apple-mobile-web-app-title"]');
      if (appleMeta) appleMeta.setAttribute('content', title);
      const appNameMeta = document.querySelector('meta[name="application-name"]');
      if (appNameMeta) appNameMeta.setAttribute('content', title);
    };

    // Check if design is already cached in localStorage
    try {
      const raw = localStorage.getItem('design');
      if (raw) {
        const design = JSON.parse(raw);
        const title = design?.title || design?.company_name;
        if (title) {
          applyTitle(title);
          return;
        }
      }
    } catch {
      // ignore
    }

    // Fetch from API
    fetchDesignAndWS()
      .then(() => {
        try {
          const raw = localStorage.getItem('design');
          if (raw) {
            const design = JSON.parse(raw);
            const title = design?.title || design?.company_name;
            if (title) {
              applyTitle(title);
            }
          }
        } catch {
          // ignore
        }
      })
      .catch(() => {});
  }, []);

  return null;
}
